module.exports = __webpack_public_path__ + "img/cooperative0_logo22.865334d5.jpg";